import React from "react"
import {Button, Row, Col, Glyphicon, FormControl} from "react-bootstrap"
import AscComponent from "../../components/AscComponent"
import CommonTable from "../../containers/Elements/Table/CommonTable"
import IpRestrictionModal from "./IpRestrictionModal"
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb"
import * as GlobalConst from "../../components/AscConstants";

export default class IpRestriction extends AscComponent {
    constructor(props) {
        super(props)
        
        this.reactContainerPath = "/Setting/IpRestriction";
        this.reactTableTarget = "/Setting/IpRestriction/board";
        
        this.state = {
            // table item
            columns:          this.getColumnsData(),
            data:             [],
            filtered:         [],
            pages:            null,
            loading:          false,

            // modal item
            show:             false,
            modalType:        null,
            
            // select item
            companySelect:    [],
            ipTypeSelect:     this.getIpTypeSelect(),
            
            // data item
            id:               "",
            company_id:       "",
            company_name:     "",
            ip_address:       "",
            ip_type:          "whitelist",
            cidr_notation:    "",
            memo:             "",
            // button_disabled
            buttondisabledArr: {
                "company_id" : []
            }
        }
    }

    getIpTypeSelect() {
        return this.props.langText.SelectOption.IpType;
    }

    getColumnsData() {
        let itemArr = [];

        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            filterable: false,
            width: this.props.boardWidth.id,
        });

        if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)){
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: "cm12_companies.company_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")} />
            });
        }

        itemArr.push({
            Header: this.props.langText.Body.IpAddress,
            accessor: "ip_address",
            width: this.props.boardWidth.medium,
            Cell: data => {
                let ipDisplay = data.row._original.ip_address;
                if (data.row._original.cidr_notation) {
                    ipDisplay += "/" + data.row._original.cidr_notation;
                }
                return <div>{ipDisplay}</div>;
            },
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "ip_address")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.IpType,
            accessor: "ip_type",
            width: this.props.boardWidth.large,
            Cell: data => {
                const ipType = data.row._original.ip_type;
                const ipTypeOption = this.props.langText.SelectOption.IpType.find(opt => opt.value === ipType);
                const label = ipTypeOption ? ipTypeOption.label : ipType;
                return <>{label}</>;
            },
            Filter: () => (
                <FormControl 
                    componentClass="select"
                    onChange={e => this.onFilterChange(e.target.value, "ip_type")}
                >
                    <option value="">{this.props.langText.SelectOption.Placeholder}</option>
                    {this.props.langText.SelectOption.IpType.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </FormControl>
            )
        });

        itemArr.push({
            Header: this.props.langText.Body.Memo,
            accessor: "memo",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "memo")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.UpdateUserName,
            accessor: "update_user_name",
            width: this.props.boardWidth.UserName,
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "update_user_name")} />
        });

        itemArr.push({
            Header: this.props.langText.Body.Modified,
            accessor: "modified",
            width: this.props.boardWidth.modified,
            Cell: ({value}) => value ? this.getMomentTime({
                format: this.props.langText.Body.DateFormat,
                date: value
            }) : "",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "modified")} />,
            filterable: false,
        });

        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.Control,
            Cell: data => {
                let rowData = [];

                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            onClick={this.modalShow("update", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="pencil"/>
                        </Button>
                    )
                } else {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            onClick={this.modalShow("read", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    )
                }
                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            onClick={this.modalShow("delete", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="minus"/>
                        </Button>
                    )
                }

                return (
                    <Row className="text-center">
                        {rowData}
                    </Row>
                )
            }
        });

        return itemArr;
    }

    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param, switchdata) => {
        switch (switchdata) {
            case "push":
                if(this.state.buttondisabledArr[param].length === 0) {
                    this.state.buttondisabledArr[param].push("dataset");
                }
                break;
            case "pop":
                this.state.buttondisabledArr[param].pop();
                break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
                break;
        }
    }

    modalShow = (modalType, param) => async event => {
        event.preventDefault()

        this.modalshow_commonInit();

        let setData = {
            id: param && param.id ? param.id : "",
            company_id: param && param.cm12_companies && param.cm12_companies.id
                ? param.cm12_companies.id
                : "",
            company_name: param && param.cm12_companies && param.cm12_companies.company_name
                ? param.cm12_companies.company_name
                : "",
            ip_address: param && param.ip_address ? param.ip_address : "",
            ip_type: param && param.ip_type ? param.ip_type : "whitelist",
            cidr_notation: param && param.cidr_notation ? String(param.cidr_notation) : "",
            memo: param && param.memo ? param.memo : "",
        };

        // 新規作成時にcompany以下なら会社固定
        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
            setData.company_id = this.props.userInfo.company_id;
            setData.company_name = this.props.userInfo.company_name;
        }
        
        this.setState(setData);

        this.getCompanySelect();

        this.setState({
            show: true, 
            modalType
        });
    }

    async onSelectChange (event, param) {
        super.onSelectChange(event, param);
    }

    /**
     * CIDR入力用のチェンジイベント（数値のみ、3桁まで、0は禁止）
     */
    onCidrChange = (event, param, limitcount) => {
        let value = event && event.target && event.target.value ? event.target.value : "";
        // 数値のみを受け付ける
        value = value.replace(/[^0-9]/g, "");
        // 0単独の場合は許可しない（空文字は許可）
        if (value === "0") {
            return;
        }
        if (value.length <= limitcount) {
            this.setState({ [param]: value });
        }
    }

    getCompanySelect = () => {
        // Setting配下のサブ機能として、Settingの権限を使用
        this.ascAxios("post", "Common/companySelect", {container: "/IpRestriction"})
            .then(res => {
                this.common_buttondisabledLengthCheck("company_id", "push");
                this.setState({
                    companySelect: res.data
                })
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data))
            })
    }

    onClickHandle = modalType => event => {
        let {
            id,
            company_id,
            ip_address,
            ip_type,
            cidr_notation,
            memo
        } = this.state;

        // 確認ポップアップ
        const confirmMessage = this.createPopupMessage(
            this.props.langText.Body.IpAddress,
            ip_address + (cidr_notation ? "/" + cidr_notation : ""),
            modalType
        );
        if (!window.confirm(confirmMessage)) {
            return;
        }
        
        switch (modalType) {
            case "insert":
                this.blockUI();
                console.log(this.reactContainerPath)
                this.ascAxios("post", `${this.reactContainerPath}/insert`, {
                    company_id,
                    ip_address,
                    ip_type,
                    cidr_notation: cidr_notation ? parseInt(cidr_notation, 10) : null,
                    memo
                })
                .then(res => {
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh();
                    this.setState({ show: false });
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                })
                break;

            case "update":
                this.blockUI();
                this.ascAxios("post", `${this.reactContainerPath}/update`, {
                    id,
                    ip_address,
                    ip_type,
                    cidr_notation: cidr_notation ? parseInt(cidr_notation, 10) : null,
                    memo
                })
                .then(res => {
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh();
                    this.setState({ show: false });
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                })
                break;

            case "delete":
                this.blockUI();
                this.ascAxios("post", `${this.reactContainerPath}/delete`, {
                    id
                })
                .then(res => {
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh();
                    this.setState({ show: false });
                })
                .catch(err => {
                    alert(this.getErrorString(err.response.data));
                })
                break;

            default:
                alert(this.getErrorString({code: "modal"}));
        }
    }

    /**
     * IPアドレスのバリデーション（IPv4/IPv6対応）
     */
    isValidIpAddress = (ip) => {
        if (!ip) return false;
        
        // IPv4の正規表現
        const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        
        // IPv6の正規表現（簡易版）
        const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]+|::(ffff(:0{1,4})?:)?((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1?[0-9])?[0-9])\.){3}(25[0-5]|(2[0-4]|1?[0-9])?[0-9]))$/;
        
        return ipv4Regex.test(ip) || ipv6Regex.test(ip);
    }

    /**
     * CIDRのバリデーション
     */
    isValidCidr = (cidr, ipAddress) => {
        if (!cidr) return true; // CIDRは任意
        
        const cidrNum = parseInt(cidr, 10);
        if (isNaN(cidrNum)) return false;
        
        // IPv4の場合: 1-32（0は禁止）
        const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (ipv4Regex.test(ipAddress)) {
            return cidrNum >= 1 && cidrNum <= 32;
        }

        // IPv6の場合: 1-128（0は禁止）
        return cidrNum >= 1 && cidrNum <= 128;
    }

    validationHandle = param => {
        let nowState = null;

        switch (param) {
            case "company_id":
                nowState = this.state[param] ? null : "error";
                break;

            case "ip_address":
                nowState = this.isValidIpAddress(this.state[param]) ? null : "error";
                break;

            case "ip_type":
                nowState = (this.state[param] === "whitelist" || this.state[param] === "blacklist") ? null : "error";
                break;

            case "cidr_notation":
                nowState = this.isValidCidr(this.state[param], this.state.ip_address) ? null : "error";
                break;

            case "insert":
            case "update":
            case "delete":
                let {company_id, ip_address, ip_type, cidr_notation} = this.state;

                nowState = (
                    company_id
                    && this.isValidIpAddress(ip_address)
                    && (ip_type === "whitelist" || ip_type === "blacklist")
                    && this.isValidCidr(cidr_notation, ip_address)
                );
                break;
            default:
        }
        return nowState;
    }

    render() {
        return (
            <div className="IpRestriction">
                <SetBreadCrumb
                    displayItems={[
                        { link: "/Setting", name: this.props.langText.Body.Setting },
                        { name: this.props.langText.Body.SettingIpRestriction },
                    ]}
                />
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id="ipRestriction-insert"
                                className="table-button"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow("insert")}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                        </Col>
                    }
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = "manual"
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}
                        />
                    </Col>
                </Row>

                <IpRestrictionModal
                    state = {this.state}
                    propSetState = {this.propSetState}
                    langText = {this.props.langText}
                    charaLimit = {this.props.charaLimit}
                    onClick = {this.onClickHandle}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    onCidrChange = {this.onCidrChange}
                    onSelectChange = {this.onSelectChange}
                    validationHandle = {this.validationHandle}
                    getScopeGreaterEqual={this.getScopeGreaterEqual}
                />
            </div>
        )
    }
}
